import React from 'react';
import { Button } from '../../ui/button';
import { Plus, Loader2, Lightbulb, Clock, Sparkles, Trash2 } from 'lucide-react';

// ChatGPT-style project history sidebar
export const AppStudioSidebar = ({
  sidebarOpen,
  isLoadingProjects,
  savedProjects,
  currentIdea,
  onNew,
  onLoadProject,
  onDeleteProject,
}) => {
  return (
    <div className={`${sidebarOpen ? 'w-72' : 'w-0'} transition-all duration-300 bg-[#252422] border-r border-[#1e3a5f]/30 flex flex-col overflow-hidden`}>
      {sidebarOpen && (
        <>
          {/* Sidebar Header */}
          <div className="p-4 border-b border-[#1e3a5f]/30 flex items-center justify-between">
            <h2 className="text-[#7dd3fc] font-semibold text-sm">Your Projects</h2>
            <Button
              onClick={onNew}
              data-testid="new-project-btn"
              className="bg-[#7dd3fc] text-[#1a1c1b] rounded-lg px-3 py-1 text-xs font-medium h-auto"
            >
              <Plus size={14} className="mr-1" />
              New
            </Button>
          </div>

          {/* Projects List */}
          <div className="flex-1 overflow-y-auto p-2">
            {isLoadingProjects ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-6 h-6 text-[#7dd3fc] animate-spin" />
              </div>
            ) : savedProjects.length === 0 ? (
              <div className="text-center py-8">
                <Lightbulb className="w-10 h-10 text-[#1e3a5f] mx-auto mb-2" />
                <p className="text-[#888680] text-xs">No projects yet</p>
                <p className="text-[#888680] text-xs">Start by describing an app idea</p>
              </div>
            ) : (
              <div className="space-y-1">
                {savedProjects.map((project) => (
                  <div
                    key={project.idea_id}
                    role="button"
                    tabIndex={0}
                    onClick={() => onLoadProject(project)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onLoadProject(project);
                      }
                    }}
                    data-testid={`project-item-${project.idea_id}`}
                    className={`w-full text-left p-3 rounded-lg transition-all group cursor-pointer ${
                      currentIdea?.idea_id === project.idea_id
                        ? 'bg-[#7dd3fc]/20 border border-[#7dd3fc]/50'
                        : 'hover:bg-[#1e3a5f]/30 border border-transparent'
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1 min-w-0 pr-2">
                        <p className={`font-medium text-sm truncate ${
                          currentIdea?.idea_id === project.idea_id ? 'text-[#7dd3fc]' : 'text-[#7dd3fc]/80'
                        }`}>
                          {project.name}
                        </p>
                        <p className="text-[#888680] text-xs truncate mt-0.5">
                          {project.description?.substring(0, 50)}...
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          <Clock className="w-3 h-3 text-[#888680]" />
                          <span className="text-[#888680] text-xs">
                            {new Date(project.created_at).toLocaleDateString()}
                          </span>
                          {project.ai_suggestions && (
                            <Sparkles className="w-3 h-3 text-[#7dd3fc]" />
                          )}
                        </div>
                      </div>
                      <button
                        onClick={(e) => onDeleteProject(project.idea_id, e)}
                        data-testid={`delete-project-${project.idea_id}`}
                        className="opacity-0 group-hover:opacity-100 p-1 hover:bg-red-500/20 rounded transition-all"
                      >
                        <Trash2 className="w-4 h-4 text-[#888680] hover:text-red-400" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
